import React, {
    useEffect, useState
} from 'react';
import { useLocation, withRouter } from 'react-router-dom';
import { MetadataContent } from '@jutro/uiconfig';
import _ from 'lodash';
import { Icon, InfoLabel, FormattedDateRange, Link } from '@jutro/components';
import PropTypes from 'prop-types';
import { generateURL } from 'gw-portals-url-js';
import { PolicyService } from 'gw-capability-policy';
// eslint-disable-next-line import/no-unresolved
import appConfig from 'app-config';
import { useAuthentication } from 'gw-digital-auth-react';
import metadata from './PaymentFrame.metadata.json5';
import styles from './PaymentFrame.module.scss';

function PaymentFrame(props) {
    
    const { match } = props;
    const { authHeader } = useAuthentication();
    const [policyResponse, setPolicyResponse] = useState([]);
    const [currentPolicy, setPolicy] = useState('');    
    const [hasLegalCollections, setHasLegalCollections] = useState(false);//FB 21547
    const location = useLocation();
    
    const auth = useAuthentication();    

    useEffect(() => {
        if (!_.isUndefined(location.state) && !_.isEmpty(location.state)) {     
            // const { auditNumber, policyNumber, serviceLocNum } = location.state;
            // setAuditNumber(auditNumber);
            // setPolicy(policyNumber);
            // setServiceLocNum(serviceLocNum);
            console.log("location.state");
        } else {

            PolicyService.getAccountPolicySummaries(authHeader).then(
                (getPolicyResponse = {}) => {
                    if (!_.isUndefined(getPolicyResponse)) {                    
                        let pn =_.get(getPolicyResponse[0].periods, '[0].policyId');
                        //FB 21547
                        const hasLegalCollectionsExt = _.get(getPolicyResponse[0].periods, '[0].hasLegalCollectionsExt');                         
                        setHasLegalCollections(hasLegalCollectionsExt === true || hasLegalCollectionsExt === 'true');
                        setPolicy(pn);
                        setPolicyResponse(getPolicyResponse);
                    } 
                }
            );
        }
            // disable re render
            // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [location]);

    const generatePaymentURL = () => {  
    
        const { match } = props; 
        if (!_.isEmpty(match.params)) {
            return generatePaymentURLWithParams(match.params.billingNumber, match.params.amount);
        }
        const getUrl = window.location;  
        const baseUrl = `${getUrl.origin}/bc/pay/#/${hasLegalCollections}`; //FB 21547
        //const baseUrl = `https://ladwpolgpe1.ri-net.com/auditpc/AuditController`;
        const redirectRoute = _.get(appConfig, 'documentNotFoundRedirectUrl') || '';
        const userId = (auth.user_name).replace("policyholder_portal_","");
        //cookie.set('token', authHeader.Authorization.replace("Bearer ", ""));
        let params = {};
        return generateURL(baseUrl, params);
    };
    
    const generatePaymentURLWithParams = (billingNumber, amount) => {
        const getUrl = window.location;
        const baseUrl = `${getUrl.origin}/bc/pay/#/pay/epay/${billingNumber}/${amount}/${hasLegalCollections}`; //FB 21547
        //const baseUrl = `https://ladwpolgpe1.ri-net.com/auditpc/AuditController`;
        const redirectRoute = _.get(appConfig, 'documentNotFoundRedirectUrl') || '';
        const userId = (auth.user_name).replace("policyholder_portal_","");
        //cookie.set('token', authHeader.Authorization.replace("Bearer ", ""));
        let params = {}; 
        return generateURL(baseUrl, params);
    };
    
    const getPaymentHeader = () => {
        let policyHolderName = null;
        let policyStatus = null;
        let policyNumber = null;
        let activePeriod = null;
        let billingNumber = null;
        let billingStatus = null;
        let startDate = null;
        let endDate = null;

        if (!_.isEmpty(policyResponse)) {
            activePeriod = _.get(policyResponse[0], 'periods');;
            
            startDate = activePeriod[0].effective;
            endDate = activePeriod[0].expiration;
            policyStatus = activePeriod[0].displayStatus; //FB 22533
            policyHolderName = activePeriod[0].displayNameExt;
            policyNumber = activePeriod[0].policyId;
            billingNumber = activePeriod[0].billingIdExt;            
            billingStatus = activePeriod[0].billingStatusExt; 
        }
        const statusClassName = billingStatus === 'Delinquent' ? styles.riInfoStatusAlert : styles.gwInfoStatus;

        return (
            <>
                <div className={styles.riSubTitle}>
                    <div>
                        Account #: &nbsp;&nbsp;
                        <span>
                            <Link to={`/ri-billing/${policyNumber}/summary`} className={styles.riLinkDetails}>
                                {billingNumber}
                            </Link>
                        </span>
                        <InfoLabel
                            id="infoStatus"
                            size="medium"
                            className={statusClassName}
                            type="info"
                            message={billingStatus}
                        />
                    </div>
                    <div className={styles.riSubTitle}>
                        Policy #: &nbsp;&nbsp;
                         <span>
                            <Link to={`/ri-policies/${policyNumber}/summary`} className={styles.riLinkDetails}>
                                {policyNumber}
                            </Link>
                        </span>
                        <span className={styles.riEffDateGroup}>
                            (
                            <FormattedDateRange
                                id="effectiveDate_1"
                                value={activePeriod}
                                startDate={new Date(startDate)}
                                endDate={new Date(endDate)}
                                hideLabel
                                displayFormat="short"
                            />
                            )
                        </span>
                        <InfoLabel
                            id="infoStatus"
                            size="medium"
                            className={styles.gwInfoStatus}
                            type="info"
                            message={policyStatus}
                        />
                    </div>
                </div>                         
                <div className={styles.gwTypeWithLOB}>
                    <Icon icon="payment" className={styles.syncIcon} />
                    <h1 className={styles.gwPageTitle}>Payment Manager</h1>
                </div>
            </>
        );
    };

    const overrides = {
        iframePayment : {
            src : generatePaymentURL({currentPolicy}),
            scrolling: 'yes', // FB 15861
            showLoader: false // FB 21547
        },
        tabPaymentTitle: {
            content: getPaymentHeader()
        },           
     };
    const resolvers = {
        resolveClassNameMap: styles,
        resolveCallbackMap: {
        },
        resolveComponentMap: {
        }
    };

    return (
        <MetadataContent
            uiProps={metadata.pageContent}
            overrideProps={overrides}
            {...resolvers}
        />
    );
}

PaymentFrame.propTypes = {
    match: PropTypes.shape({
        path: PropTypes.string,
        params: PropTypes.shape({
            billingNumber: PropTypes.string,
            amount: PropTypes.string
        }),
        url: PropTypes.string
    })};

export default withRouter(PaymentFrame)
